export class GetOrganizationStatistics {
  static readonly type = "[Dashboard Page] Get Organization Statistics";
}
